import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=22e52579&scoped=true&"
import script from "./TheNavbar.vue?vue&type=script&lang=js&"
export * from "./TheNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbar.vue?vue&type=style&index=0&id=22e52579&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e52579",
  null
  
)

export default component.exports